export default {"src":"/_next/static/media/golf-digest.ca5e38a5.svg","height":32,"width":157,"blurWidth":0,"blurHeight":0};